import { getProductConfig } from '@/app/config/products.config';
import type { ProposalSummary } from '@/services/proposals/types';
import { PortalStatus } from '@/shared/enums/portal-status.enum';

/** Produto com fluxo de proposta Capital Global — `usesCapitalGlobalProposal` em `products.config`. */
export function isCapitalGlobalProposalProduct(
  productCode: string | undefined | null
): boolean {
  if (productCode == null || productCode === '') return false;
  return getProductConfig(productCode)?.usesCapitalGlobalProposal === true;
}

/** Identifica Capital Global na listagem (usa nome do produto retornado pelo BFF). */
export function isCapitalGlobalProposalFromSummary(
  proposal: Pick<ProposalSummary, 'productName'>
): boolean {
  const name = (proposal.productName || '').toLowerCase();
  return name.includes('capital global');
}

/** Proposta CG editável apenas em digitação (status 6), antes de enviar para assinatura. */
export function canEditCapitalGlobalProposalFromSummary(
  proposal: Pick<ProposalSummary, 'proposalStatus'>
): boolean {
  return proposal.proposalStatus === String(PortalStatus.ProposalInProgress);
}
